import Manageservice from "./Pages/Manageservice";
import './App.css';
import {createBrowserRouter,Route,RouterProvider, Routes, useNavigate } from "react-router-dom";
import ManageClient from "./Pages/ManageClient";
import MangePortifolio from "./Pages/MangePortifolio";
import ManageContact from "./Pages/ManageContact";
import ManageUserProfile from "./Pages/ManageUserProfile";
import Setting from "./Pages/Setting";
import ManageBlog from "./Pages/ManageBlog";
import AddService from "./Pages/AddService";
import AddContact from "./Pages/AddContact";
import AddBlog from "./Pages/AddBlog";
import AddProject from "./Pages/AddProject";
import AddTestimonal from "./Pages/AddTestimonal";
import AddUser from "./Pages/AddUser";
import Login from "./Pages/Login/Login";
import { useContext, useEffect } from "react";
import { UserContex } from "./context API/UserContext";
import axios from "axios";
import UpdateBlog from "./Pages/UpdateBlog";
import UpdateService from "./Pages/UpdateService";
import UpdateContact from "./Pages/UpdateContact";
import UpdateProject from "./Pages/UpdateProject";
import ChangePassword from "./Pages/ChangePassword";
import ClientReply from "./Pages/ClientReply"
function App() {
   const [userData, setUserData,loading] = useContext(UserContex);
  const navigate=useNavigate()
   const logout = () => {
     localStorage.removeItem("auth-token");
     localStorage.removeItem("user");
      setUserData({
        token: undefined,
        user: undefined,
      });
     //  localStorage.setItem("auth-token", "");
   };
  //  const router = createBrowserRouter([
  //    {
  //      path: "/",
  //      element: <Manageservice logout={logout} />,
  //    },
  //    {
  //      path: "/addservice",
  //      element: <AddService />,
  //    },
  //    {
  //      path: "/updateservice/:id",
  //      element: <UpdateService />,
  //    },
  //    {
  //      path: "/addcontact",
  //      element: <AddContact />,
  //    },
  //    {
  //      path: "/updatecontact/:id",
  //      element: <UpdateContact />,
  //    },
  //    {
  //      path: "/addblog",
  //      element: <AddBlog />,
  //    },
  //    {
  //      path: "/updateblog/:id",
  //      element: <UpdateBlog />,
  //    },
  //    {
  //      path: "/addproject",
  //      element: <AddProject />,
  //    },
  //    {
  //      path: "/updateproject/:id",
  //      element: <UpdateProject />,
  //    },
  //    {
  //      path: "/addcompany",
  //      element: <AddTestimonal />,
  //    },
  //    {
  //      path: "/client",
  //      element: <ManageClient logout={logout} />,
  //    },
  //    {
  //      path: "/clientreply/:id",
  //      element: <ClientReply logout={logout} />,
  //    },
  //    {
  //      path: "/portifolio",
  //      element: <MangePortifolio logout={logout} />,
  //    },
  //    {
  //      path: "/contact",
  //      element: <ManageContact logout={logout} />,
  //    },
  //    {
  //      path: "/profile",
  //      element: <ManageUserProfile logout={logout} />,
  //    },
  //    {
  //      path: "/adduser",
  //      element: <AddUser />,
  //    },
  //    {
  //      path: "/changepassword",
  //      element: <ChangePassword />,
  //    },
  //    {
  //      path: "/setting",
  //      element: <Setting logout={logout} />,
  //    },
  //    {
  //      path: "/blog",
  //      element: <ManageBlog logout={logout} />,
  //    },
  //    {
  //      path: "/login",
  //      element: <Login />,
  //    },
  //  ]);
   useEffect(() => {
    //  localStorage.clear()
     if (!loading) {
       if (!userData.token) {
         navigate("/login");
       }
     }
   }, [userData, navigate, loading]);
   if (loading) {
     return <div>Loading...</div>;
   }
   return (
     <div className="App">
       <Routes>
         <Route path="/login" element={<Login />} />
         <Route path="/" element={<Manageservice logout={logout} />} />
         <Route path="/adduser" element={<AddUser />} />
         <Route path="/changepassword" element={<ChangePassword />} />
         <Route path="/profile" element={<ManageUserProfile />} />
         <Route path="/client" element={<ManageClient logout={logout} />} />
         <Route
           path="/clientreply/:id"
           element={<ClientReply logout={logout} />}
         />
         <Route
           path="/portifolio"
           element={<MangePortifolio logout={logout} />}
         />
         <Route path="/contact" element={<ManageContact logout={logout} />} />
         <Route path="/setting" element={<Setting logout={logout} />} />
         <Route path="/blog" element={<ManageBlog logout={logout} />} />
         <Route path="/addservice" element={<AddService />} />
         <Route path="/updateservice/:id" element={<UpdateService />} />
         <Route path="/addcontact" element={<AddContact />} />
         <Route path="/updatecontact/:id" element={<UpdateContact />} />
         <Route path="/addblog" element={<AddBlog />} />
         <Route path="/updateblog/:id" element={<UpdateBlog />} />
         <Route path="/addproject" element={<AddProject />} />
         <Route path="/updateproject/:id" element={<UpdateProject />} />
         <Route path="/addcompany" element={<AddTestimonal />} />
       </Routes>
     </div>
   );
}

export default App;
